const DESKTOP_HEIGHTS = {
  small: 360,
  medium: 440,
  large: 540,
  extra: 720,
};

const MOBILE_HEIGHTS = {
  small: 240,
  medium: 360,
  large: 460,
};

function pixels(key, custom, table, fallback) {
  if (key === "adapt") return "auto";
  if (key === "fullscreen") return "100svh";
  if (key === "custom") {
    const size = Number.parseInt(custom, 10);
    if (Number.isFinite(size)) return `${Math.min(1200, Math.max(160, size))}px`;
    return `${fallback}px`;
  }
  if (table[key]) return `${table[key]}px`;
  return `${fallback}px`;
}

export function bannerFrame(settings = {}, fallback = "large") {
  const desktopKey = settings.bannerHeight || fallback;
  const mobileKey = settings.bannerHeightMobile || "same";
  const fit = settings.bannerFit === "contain" ? "contain" : "cover";
  const desktop = pixels(desktopKey, settings.bannerHeightCustom, DESKTOP_HEIGHTS, DESKTOP_HEIGHTS[fallback] || 540);
  const mobile = mobileKey === "same"
    ? desktop
    : pixels(mobileKey, settings.bannerHeightCustomMobile, MOBILE_HEIGHTS, 360);

  return {
    adapt: desktopKey === "adapt",
    adaptMobile: mobileKey === "adapt" || (mobileKey === "same" && desktopKey === "adapt"),
    fit,
    width: settings.bannerWidth === "page" ? "page" : "full",
    style: {
      "--banner-height": desktop,
      "--banner-height-mobile": mobile,
      "--banner-fit": fit,
    },
  };
}

export const BANNER_SIZE_FIELDS = [
  {
    key: "bannerHeight",
    label: "Desktop height",
    type: "select",
    group: "size",
    options: [
      { value: "small", label: "Small" },
      { value: "medium", label: "Medium" },
      { value: "large", label: "Large" },
      { value: "extra", label: "Extra large" },
      { value: "fullscreen", label: "Full screen" },
      { value: "custom", label: "Custom height" },
    ],
  },
  {
    key: "bannerHeightCustom",
    label: "Custom desktop height (px)",
    type: "number",
    group: "size",
    min: 160,
    max: 1200,
    placeholder: "540",
    showWhen: { key: "bannerHeight", value: "custom" },
  },
  {
    key: "bannerHeightMobile",
    label: "Phone height",
    type: "select",
    group: "size",
    options: [
      { value: "same", label: "Same as desktop" },
      { value: "small", label: "Small" },
      { value: "medium", label: "Medium" },
      { value: "large", label: "Large" },
      { value: "custom", label: "Custom height" },
    ],
  },
  {
    key: "bannerHeightCustomMobile",
    label: "Custom phone height (px)",
    type: "number",
    group: "size",
    min: 160,
    max: 1200,
    placeholder: "360",
    showWhen: { key: "bannerHeightMobile", value: "custom" },
  },
  {
    key: "bannerFit",
    label: "Photo fit",
    type: "select",
    group: "size",
    options: [
      { value: "cover", label: "Fill the frame" },
      { value: "contain", label: "Show the whole photo" },
    ],
  },
  {
    key: "bannerWidth",
    label: "Width",
    type: "select",
    group: "size",
    options: [
      { value: "full", label: "Full width" },
      { value: "page", label: "Page width" },
    ],
  },
];

export const IMAGE_BANNER_SIZE_FIELDS = [
  {
    ...BANNER_SIZE_FIELDS[0],
    options: [
      { value: "adapt", label: "Adapt to the image" },
      ...BANNER_SIZE_FIELDS[0].options,
    ],
  },
  BANNER_SIZE_FIELDS[1],
  {
    ...BANNER_SIZE_FIELDS[2],
    options: [
      { value: "same", label: "Same as desktop" },
      { value: "adapt", label: "Adapt to the image" },
      ...BANNER_SIZE_FIELDS[2].options.slice(1),
    ],
  },
  BANNER_SIZE_FIELDS[3],
  {
    ...BANNER_SIZE_FIELDS[4],
    showWhen: { key: "bannerHeight", values: ["small", "medium", "large", "extra", "fullscreen", "custom"] },
  },
  BANNER_SIZE_FIELDS[5],
];
